<template>
  <div class="as-matches" ref="scrollComponent">
    <div v-for="index in 6" :key="index" class="as-competition-wrapper">
      <div class="as-league_title">
        <SkeletonLoader width="30px" height="30px" mode="circle" :line="1" />
        <SkeletonLoader width="130px" height="20px" :line="1" />
      </div>

      <div class="as-match__item">
        <div class="as-match__time">
          <SkeletonLoader width="100px" height="20px" :line="1" />
        </div>
        <div class="as-match__teams">
          <div class="as-match__team as-match__team--home">
            <SkeletonLoader width="40px" height="40px" mode="circle" :line="1" />
            <div class="as-match__team--name as-match__team-home-name">
              <SkeletonLoader width="120px" height="20px" :line="1" />
            </div>
          </div>
          <SkeletonLoader width="40px" height="40px" :line="1" />
          <div class="as-match__team as-match__team--away">
            <SkeletonLoader width="40px" height="40px" mode="circle" :line="1" />
            <div class="as-match__team--name as-match__team-away-name">
              <SkeletonLoader width="120px" height="20px" :line="1" />
            </div>
          </div>
        </div>
        <div class="as-match__play">
          <SkeletonLoader width="40px" height="40px" :line="1" />
        </div>
        <div class="as-match__round">
          <SkeletonLoader width="100px" height="20px" :line="1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
const commonStore = usecommonStore();

interface IProps {
}

const props = withDefaults(defineProps<IProps>(), {});

const siteName = computed(() => commonStore.getSiteName);
</script>
